import React, { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { GTOB_TOKEN_IDENTIFIER } from '../../constants'
import { setIsLoggedIn } from '../../pages/login/slice'
import getAccessToken from '../../pages/login/actions'
import Token from '../../token'

export default function Authenticator({ children }: { children: JSX.Element }) {
  const dispatch = useAppDispatch()
  const token = localStorage.getItem(GTOB_TOKEN_IDENTIFIER)
  const { isLoggedIn, nextURL } = useAppSelector((state) => state.login)
  const [searchParams] = useSearchParams()
  const authorizationCode = searchParams.get('code')

  useEffect(() => {
    if (authorizationCode) {
      return
    }

    if (token && Token.hasRequiredScopes()) {
      dispatch(setIsLoggedIn(true))
      return
    }

    if (token) {
      Token.clearStoredToken()
    }
  }, [token, authorizationCode]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (authorizationCode) {
      dispatch(getAccessToken(authorizationCode))
    }
  }, [authorizationCode]) // eslint-disable-line react-hooks/exhaustive-deps

  const nextRender = () => {
    if (nextURL) {
      window.location.replace(nextURL)
    }
    return children
  }

  const hasValidSession = (isLoggedIn || token) && Token.hasRequiredScopes()

  return hasValidSession ? (
    nextRender()
  ) : (
    <Navigate to={`/login?next=${window.location.href}`} state={window.location.href} />
  )
}
